import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, finalize, throwError } from 'rxjs';
import { ToastService } from '../../shared/ui/toast.service';
import { ApiActivity } from './api-activity';

/** Background polling (such as the bell's unread count) does not show the busy bar. */
const QUIET_PATHS = ['/unread-count'];

/**
 * Every API call: counts it for the busy bar, and tells the user about the failures no screen handles itself
 * (no connection, forbidden, server errors). Expired sessions are handled by the JWT interceptor, which runs first.
 */
export const apiInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.includes('/api/')) return next(req);

  const activity = inject(ApiActivity);
  const toast = inject(ToastService);
  const quiet = QUIET_PATHS.some((path) => req.url.includes(path));
  const write = !['GET', 'HEAD'].includes(req.method);
  if (!quiet) activity.start(write);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) notify(error, toast.danger.bind(toast));
      return throwError(() => error);
    }),
    finalize(() => {
      if (!quiet) activity.end(write);
    })
  );
};

function notify(error: HttpErrorResponse, danger: (title: string, message?: string) => void): void {
  if (error.status === 0) {
    danger('Cannot reach the server', 'Check your connection, then try again.');
  } else if (error.status === 403) {
    danger('Not allowed', 'You do not have access to do that.');
  } else if (error.status >= 500) {
    danger('Something went wrong on the server', 'Please try again in a moment.');
  }
}
